import React from 'react';
import HeroImage from '../Assets/about.png';
import { PopupButton } from 'react-calendly';

const About = () => {
  return (
    <section
      id="about"
      className="w-full bg-white py-10 px-6 md:px-12 lg:px-20 xl:px-28 flex flex-col-reverse md:flex-row items-center justify-between gap-8 max-w-screen-xl mx-auto"
    >
      {/* Left Content */}
      <div className="w-full md:w-1/2 flex flex-col items-start justify-center">
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-black leading-tight text-left">
          Build <span className="text-orange-500">Awesome</span>
          <br />
          Products.
          <br />
          Fast!
        </h1>

        <p className="text-base sm:text-lg md:text-xl text-gray-700 font-medium mt-4 text-left">
          Our Product Specialists are capable pioneers and subject
          <br className="hidden sm:block" />
          matter experts who are client-centered.
        </p>

        <PopupButton
          url="https://calendly.com/mydatalab?hide_gdpr_banner=1"
          rootElement={document.getElementById('root')}
          text="BOOK A CALL"
          className="mt-6 bg-orange-500 hover:bg-orange-600 text-white font-semibold text-sm sm:text-base md:text-lg px-6 py-3 rounded transition duration-200"
        />
      </div>

      {/* Right Image */}
      <div className="w-full md:w-1/2 flex justify-center items-center">
        <img
          src={HeroImage}
          alt="Business Plan Illustration"
          className="w-full h-auto max-w-md md:max-w-full object-contain"
        />
      </div>
    </section>
  );
};

export default About;
